import "react";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import { selectors } from "../model/index.js";
function useCreditData(vehicleId = "") {
  return useAppSelector((state) => selectors.selectById(state.credit, vehicleId));
}
export {
  useCreditData
};
